import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../css/DashboardLayout.css";

const DashboardLayout = ({ children }) => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  const menuItems = [
    { name: "View Transactions", path: "/viewTransactions", icon: "bi bi-journal-text" },
    { name: "Add Debtor", path: "/addDebitor", icon: "bi bi-person-plus" },
    { name: "Add Creditor", path: "/addCreditor", icon: "bi bi-wallet2" },
    { name: "Generate Image", path: "/generateImage", icon: "bi bi-image" },
    { name: "View Debtors", path: "/debitors", icon: "bi bi-people" },
    { name: "View Creditors", path: "/creditors", icon: "bi bi-briefcase" },
    { name: "Upcoming Tasks", path: "/upcomingTasks", icon: "bi bi-calendar-check" },
  ];

  return (
    <div className="dashboard-container">
      {/* Always visible toggle button */}
      <button
        className="top-toggle-btn"
        onClick={() => setCollapsed(!collapsed)}
        aria-label="Toggle sidebar"
      >
      ☰
      </button>

      {/* Sidebar (hidden completely when collapsed) */}
      {!collapsed && (
        <div className="sidebar">
          <div className="sidebar-header">
            <br></br>
          </div>

          <ul>
            {menuItems.map((item, index) => (
              <li key={index}>
                <Link
                  to={item.path}
                  className={location.pathname === item.path ? "active" : ""}
                >
                  <i className={item.icon}></i>
                  <span className="link-text">{item.name}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Main Content expands full width if sidebar hidden */}
      <div className={`main-content ${collapsed ? "full-width" : ""}`}>
        {children}
      </div>
    </div>
  );
};

export default DashboardLayout;
